import { z } from 'zod';

export const xpIntegrationConfigSchema = z.object({
  xp_office_id: z.array(z.string().min(1)).min(1),
  delta_date: z.number().default(0),
});
